module.exports = __webpack_public_path__ + "static/media/MonthlyLossOrIncome.c9962f6b.svg";